import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import esriConfig from '@arcgis/core/config.js';

esriConfig.log.level = 'error';
bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
